export default __webpack_public_path__ + "static/media/coding.8e81c76a.svg";